export const HIERARCHY_TYPES_FETCH_FAILURE =
  'hierarchy/HIERARCHY_TYPES_FETCH_FAILURE';
export const HIERARCHY_TYPES_FETCH_SUCCESS =
  'hierarchy/HIERARCHY_TYPES_FETCH_SUCCESS';
export const LOCATION_PARSED = 'hierarchy/LOCATION_PARSED';
export const RESET_RELOAD = 'hierarchy/RESET_RELOAD';
export const SELECTOR_LOCATION_PARSED = 'hierarchy/SELECTOR_LOCATION_PARSED';
export const SELECTOR_RESET_RELOAD = 'hierarchy/SELECTOR_RESET_RELOAD';
